import React from 'react';
import ReactDOM from 'react-dom';

import PlanMyTraining from "./Components/PlanMyTraining.jsx";

const App = ({data}) => {
  const planSection = document.getElementById('plan-my-training');

  return (
    <>
      <div className="button-cta btn plan-training-cta">
        <a href="#plan-my-training">
          <span>{Drupal.t("Planifier ma formation")}</span>
          <span className="btn-submit--icon icon-arrow-right" aria-hidden="true"></span>
        </a>
      </div>

      {planSection && ReactDOM.createPortal(
        <PlanMyTraining data={data} />,
        planSection
      )}
    </>
  );
};

export default App;
